<template>
    <v-container>
        <v-row class="customTitle" style="padding-bottom: 30px">
            3D Surface Plot
        </v-row>
        <v-row>
<!--            <img src="../../../assets/images/screenshots/SurfacePlotScreenshot.png"-->
<!--                 alt="React Energy - Interval Data Analysis"-->
<!--                 class="productImage"-->

<!--            />-->
            <v-container style="display: flex; justify-items: center">
                <div style="margin: auto" class="homeSection1Image">
                    <img src="../../../assets/images/screenshots/SurfacePlotScreenshot.png"
                         alt="React Energy - Interval Data Analysis"
                         style="width: 100%"
                         class="productImage"
                    />
                </div>
            </v-container>
        </v-row>
        <v-row class="customTitle" style="font-size: 2em; padding: 10px 0">
            General
        </v-row>
        <v-row class="customDescriptionText">
            The Surface Plot create a three-dimensional rendering of your energy data. Easily spot peaks in energy usage or changes in scheduling.

        </v-row>

        <v-row class="customTitle" style="font-size: 2em; padding: 10px 0">
            Data Types
        </v-row>
        <v-row class="customDescriptionText">
            <ul>
                <li>Kilowatts (kW)</li>
                <li>Kilowatt-hours (kWh)</li>
            </ul>

        </v-row>
        <Days/>
        <Months/>
        
        

    </v-container>
</template>


<script>
    import SummaryLevels from './FilterOptions/SummaryLevels'
    import SeriesType from './FilterOptions/SeriesType'
    import Days from './FilterOptions/Days'
    import Months from './FilterOptions/Months'
    
    export default {
        components: {
            SummaryLevels,
            SeriesType,
            Days,
            Months
        }
    }
</script>